export const DEVELOPMENT_AMPLITUDE_KEY = 'fa7be48760ea5d43d171740570b3e514';
export const PRODUCTION_AMPLITUDE_KEY = '43b6511a0a52017a1f61f7a3c3c61f6a';
